export default __webpack_public_path__ + "static/media/BegumSans-Regular.bd5dc13f.ttf";